/* eslint-disable no-continue */
/**
 * Created by Xinhe on 2018/8/4.
 */

const trim = function(string) {
  return (string || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
};

/**
 * 处理dom class的辅助方法
 */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(" ") !== -1)
    throw new Error("className should not contain space.");
  if (el.classList) {
    return el.classList.contains(cls);
  }
  return ` ${el.className} `.indexOf(` ${cls} `) > -1;
}

// function addClass(el, cls) {
//   if (!el) return;
//   let curClass = el.className;
//   const classes = (cls || "").split(" ");

//   for (let i = 0, j = classes.length; i < j; i++) {
//     const clsName = classes[i];
//     if (!clsName) continue;

//     if (el.classList) {
//       el.classList.add(clsName);
//     } else if (!hasClass(el, clsName)) {
//       curClass += ` ${clsName}`;
//     }
//   }
//   if (!el.classList) {
//     el.className = curClass;
//   }
// }

export function removeClass(el, cls) {
  if (!el || !cls) return;
  const classes = cls.split(" ");
  let curClass = ` ${el.className} `;

  for (let i = 0, j = classes.length; i < j; i++) {
    const clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(` ${clsName} `, " ");
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

/**
 * 具体transition方法函数
 * 内部
 * beforeEnter，enter，afterEnter
 * beforeLeave，leave，afterLeave为transition处理方法
 */
const getTransitionEvent = (duration, timingFunction, _this) => {
  const getTransition = (duration, timingFunction) => {
    const properties = ["height", "padding-top", "padding-bottom"];
    return properties
      .map(prop => `${duration}s ${prop} ${timingFunction}`)
      .join(",");
  };
  const on = {
    beforeEnter(el) {
      _this.$emit("beforeEnter");
      // addClass(el, 'collapse-transition')
      el.style.transition = getTransition(duration, timingFunction);

      if (!el.dataset) el.dataset = {};

      el.dataset.oldPaddingTop = el.style.paddingTop;
      el.dataset.oldPaddingBottom = el.style.paddingBottom;

      el.style.height = "0";
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    },

    enter(el) {
      _this.$emit("enter");
      el.dataset.oldOverflow = el.style.overflow;
      if (el.scrollHeight !== 0) {
        el.style.height = `${el.scrollHeight}px`;
        el.style.paddingTop = el.dataset.oldPaddingTop;
        el.style.paddingBottom = el.dataset.oldPaddingBottom;
      } else {
        el.style.height = "";
        el.style.paddingTop = el.dataset.oldPaddingTop;
        el.style.paddingBottom = el.dataset.oldPaddingBottom;
      }

      el.style.overflow = "hidden";
    },

    afterEnter(el) {
      // for safari: remove class then reset height is necessary
      // removeClass(el, 'collapse-transition')
      el.style.transition = "";
      el.style.height = "";
      el.style.overflow = el.dataset.oldOverflow;
      _this.$emit("afterEnter");
    },

    beforeLeave(el) {
      _this.$emit("beforeLeave");
      if (!el.dataset) el.dataset = {};
      el.dataset.oldPaddingTop = el.style.paddingTop;
      el.dataset.oldPaddingBottom = el.style.paddingBottom;
      el.dataset.oldOverflow = el.style.overflow;

      el.style.height = `${el.scrollHeight}px`;
      el.style.overflow = "hidden";
    },

    leave(el) {
      _this.$emit("leave");
      if (el.scrollHeight !== 0) {
        // for safari: add class after set height, or it will jump to zero height suddenly, weird
        // addClass(el, 'collapse-transition')
        el.style.transition = getTransition(duration, timingFunction);
        el.style.height = 0;
        el.style.paddingTop = 0;
        el.style.paddingBottom = 0;
      }
    },

    afterLeave(el) {
      el.style.transition = "";
      el.style.height = "";
      el.style.overflow = el.dataset.oldOverflow;
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
      _this.$emit("afterLeave");
    },

    leaveCancelled(el) {
      el.style.transition = "";
      el.style.height = "";
      el.style.overflow = el.dataset.oldOverflow;
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }
  };
  return on;
};

/**
 * 组件通过render函数对slot外套<transition>标签
 * 响应方法参考getTransitionEvent()函数
 */
export default {
  props: ["duration", "timingFunction"],
  name: "SJCollapseTransition",
  render(h) {
    return h(
      "transition",
      {
        on: getTransitionEvent(this.duration, this.timingFunction, this)
      },
      this.$slots.default
    );
  }
};
